const getters = {
  organisationId: state => {
    return state.organisationid
  },
  modules: state => {
    return state.modules
  },
  userId: state => {
    return state.user.id
  },
  englishDate: state => {
    return state.isEnglishDateEnabled
  },
  nepaliNewDate: state => {
    return state.nepaliNewDate
  },
  fyId: state => {
    return state.fyId
  },
  enable2FA: state => {
    return state.enable2FA
  },
  organisationIRDActive: state => {
    return state.organisationIRDActive
  },
  irdUsername: state => {
    return state.irdUsername
  },
  irdPassword: state => {
    return state.irdPassword
  },
  fiscalYear: state => {
    return state.fiscalYear
  },
  startDate: state => {
    return state.startDate
  },
  endDate: state => {
    return state.endDate
  },
  warehouseId: state => {
    return state.warehouseData
  },
  counterId: state => {
    return state.counterData
  },
  fyName: state => {
    return state.fyName
  },
  organisationLogo: state => {
    return state.organisationLogo
  },
  organisationPanVatNo: state => {
    return state.organisationPanVatNo
  },
  taxType: state => {
    return state.taxType
  },
  orgRemarks: state => {
    return state.orgRemarks
  },
  ablePrintRealTime: state => {
    return state.ablePrintRealTime
  }
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js